import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  actionsList: {
    display: 'flex',
    gap: '16px',
  },
  chooseAnAction: {
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '20px',
    padding: '20px 0',
    color: '1E1E1E',
  },
  commonInput: {
    '& .MuiInputBase-root': {
      minHeight: '44px',
      '& fieldset': {
        border: '1px solid rgba(30, 30, 30, 0.10) !important',
        borderRadius: '8px',
        outlineStyle: 'none',
      },
    },
    '& .MuiBox-root': {
      display: 'flex',
      gap: '8px',
      margin: '0',
    },
    '& .MuiAutocomplete-root': {
      width: '100%',
    },
    '& .MuiInputBase-root:hover fieldset, .MuiInputBase-root:focus fieldset, .MuiInputBase-root:focus-visible, .MuiInputBase-root:focus-visible fieldset': {
      border: '1px solid #6C59E6',
      background: 'rgba(108, 89, 230, 0.05)',
    },
    '& .label': {
      color: '#1E1E1E',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '20px',
    },
    '& input': {
      padding: '3.5px 4px 3.5px 5px!important',
    },
  },
}));
